import React from "react";
import {Component} from "react";
import { withRouter, Redirect } from "react-router";
import app from "./base";
import backBanner from "./backBanner.jpg"
import logoParkvillegreens from "./logoParkvillegreens.png"

const project_code = "parkville_greens_erin_gates";
var event_type_name_holder;
var invitee_email_holder;
var event_start_time_holder;
var event_start_time_unix;
var invitee_full_name_holder;
var finalLink;
var assigned_to;
var user_phone_number;
var appointmentFullName;
var doOnce = 0;
var guest_1 = "undefined";
var guest_2 = "undefined";
var guest_3 = "undefined";
var guest_4 = "undefined";


class Confirmation extends Component {
    componentDidMount() {

        console.log("COMPONENT DID MOUNT");
        //read url here

        var currentHref = window.location.href;

        var splitter = currentHref.split("?");//this is the entire string so split by & and we have an array
    
        var split1 = splitter[1];
    
        var arrayOfAllItems = split1.split("&");

        arrayOfAllItems.forEach(element => {
            if (element.includes("event_type_name")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%20/g, "_");
        
                event_type_name_holder = replacer;

                var setEventName = document.getElementById("title")
                setEventName.innerHTML = event_type_name_holder;
                //still need to parse this more
            }
        
            if (element.includes("invitee_email")) {
                var split = element.split("=");
        
                var replacer = split[1].replace("%40", "@");
        
                invitee_email_holder = replacer;

                var setEventEmail = document.getElementById("userEmail")
                setEventEmail.innerHTML = invitee_email_holder;
            }
        
            if (element.includes("event_start_time")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%3A/g, ":");
        
                event_start_time_holder = replacer;

                var replaceAgain = replacer.replace("-04:00", "");
                
                event_start_time_holder = replaceAgain;


                var setEventTime = document.getElementById("startTime")

                

                setEventTime.innerHTML = event_start_time_holder;
            }
        
            if (element.includes("invitee_full_name")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%20/g, " ");
        
                invitee_full_name_holder = replacer;

                var setInvitee = document.getElementById("fullName")
                setInvitee.innerHTML = invitee_full_name_holder;
            }

            if (element.includes("assigned_to")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%20/g, "_");
        
                assigned_to = replacer;

                
            }
            //answer_2=
            if (element.includes("answer_1")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%20/g, " ");
                var moreReplace = replacer.replace(/%2B1 /g, "");

                user_phone_number = moreReplace;

                var setPhone = document.getElementById("userPhone")
                setPhone.innerHTML = user_phone_number;
            }

            if (element.includes("answer_2")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%40/g, "@");
                var moreReplace = replacer.replace(/%2B1 /g, "");

                guest_1 = moreReplace;

            }

            if (element.includes("answer_3")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%40/g, "@");
                var moreReplace = replacer.replace(/%2B1 /g, "");

                guest_2 = moreReplace;

            }

            if (element.includes("answer_4")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%40/g, "@");
                var moreReplace = replacer.replace(/%2B1 /g, "");

                guest_3 = moreReplace;

            }

            if (element.includes("answer_5")) {
                var split = element.split("=");
        
                var replacer = split[1].replace(/%40/g, "@");
                var moreReplace = replacer.replace(/%2B1 /g, "");

                guest_4 = moreReplace;

            }
            
        });
        //Assign guests here

        if(guest_1 !== "undefined"){
            var guestList = document.getElementById("guestList")
            guestList.innerHTML = "";
            //var breakElement = document.createElement("br");
            var newP = document.createElement("p");
            newP.className = "paragraphRegList";
            newP.innerHTML = guest_1;
            guestList.appendChild(newP);
        }
        if(guest_2 !== "undefined"){
            var guestList = document.getElementById("guestList")
            //var breakElement = document.createElement("br");
            var newP = document.createElement("p");
            newP.className = "paragraphRegList";
            newP.innerHTML = guest_2;
            guestList.appendChild(newP);
        }
        if(guest_3 !== "undefined"){
            var guestList = document.getElementById("guestList")
            //var breakElement = document.createElement("br");
            var newP = document.createElement("p");
            newP.className = "paragraphRegList";
            newP.innerHTML = guest_3;
            guestList.appendChild(newP);
        }
        if(guest_4 !== "undefined"){
            var guestList = document.getElementById("guestList")
            //var breakElement = document.createElement("br");
            var newP = document.createElement("p");
            newP.className = "paragraphRegList";
            newP.innerHTML = guest_4;
            guestList.appendChild(newP);
        }

        
        appointmentFullName = event_type_name_holder + "With_" + assigned_to

        var setEventNameAgain = document.getElementById("title")
        var nameNoSpaces = appointmentFullName.replace(/_/g, " ");
        setEventNameAgain.innerHTML = nameNoSpaces;
        //need to find out if there is an appointment at this time
        // //if their is an appointment at this time for this callender                                                                                    
        const findAppointment = () =>{
            
            let appointmentTime = new Date(event_start_time_holder);
            var timeMili = appointmentTime.getTime();
//firebase.database().ref('/client_emails/' + projCode + '/emails').orderByChild('email').equalTo(userEmail).once("value").then( function (snapshot) {
            console.log("finding appointment " + appointmentFullName + "at time : " + timeMili + " time" + appointmentTime);

            //may need to change search by assigned_to later
            app.database().ref('/client_appointments/' + project_code).orderByChild("appointmentName").equalTo(appointmentFullName).once('value', snapshot => {
                console.log(snapshot);
                var snapshotArray = snapshot;
                var foundAppointment = false;
                var foundAppointmentData;
                snapshotArray.forEach(element => {
                    console.log(element.val().timeOfAppointment);
                    var timeOfChildApp = element.val().timeOfAppointment
                    var assignedToParent = element.val().assignedTo
                    if(timeOfChildApp == timeMili && assignedToParent === assigned_to){
                        console.log("FOUND USERS APPOINTMENT KEY = " + element.val().appointmentID +" key "+ element.key);
                        foundAppointment = true;
                        foundAppointmentData = element;
                    }

                    
                });

                if(foundAppointment == true){
                    pushUserDataToAppointment(foundAppointmentData);
                    // var newPostRef = postListRef.push();
                    // newPostRef.set({
                    //     // ...
                    // });

                }
                else{
                    setNewAppointment();
                }
                //snapshot is going to be a list of all appointments by that person need to find the time
                //compare to find which child has time mili
        
            });
             

        };

        
        //use a similar function to push all the data
        const pushUserDataToAppointment = (snapshot) =>{

            var appointmentSnapshot = snapshot;

            var userPostRef = app.database().ref('/client_appointments/' + project_code + "/" + snapshot.key + "/users").push();
                //this generates push id then we push use set to push user


            userPostRef.set({
                email: invitee_email_holder,
                fullName: invitee_full_name_holder,
                phoneNumber: user_phone_number
            });
            
            //create link
            //pushID of the appointmengt + "_" + pushID
            var startRef = currentHref.split("/c");
            var urId = userPostRef.key;
            var newRef = startRef[0] + "?linkId=" +snapshot.key +"_split_" + urId;

            finalLink = newRef;
            //invitee_full_name_holder
            //invitee_email_holder
            //user_phone_number
            var setLink = document.getElementById("link")
            setLink.innerHTML = "Joing Meeting";

            setLink.onclick = () => {AppointmentClick()};

            //set users email to the appointment list
            var emailPost = app.database().ref('/client_emails/' + project_code).push();

            let appointmentTimeTemp = new Date(event_start_time_holder);
            var timeMiliTemp = appointmentTimeTemp.getTime();

            emailPost.set({
                email:invitee_email_holder,
                appointmentID: snapshot.key,
                timeOfAppointment: timeMiliTemp
            });


            //do all things above for guests
            if(guest_1 !== "undefined"){
                var guestPostRef1 = app.database().ref('/client_appointments/' + project_code + "/" + snapshot.key + "/users").push();

                guestPostRef1.set({
                    email: guest_1,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost1 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost1.set({
                        email:guest_1,
                        appointmentID: snapshot.key,
                        timeOfAppointment: timeMiliTemp
                    });
                },1000);
            }
            if(guest_2 !== "undefined"){
                var guestPostRef2 = app.database().ref('/client_appointments/' + project_code + "/" + snapshot.key + "/users").push();
                
                guestPostRef2.set({
                    email: guest_2,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost2 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost2.set({
                        email:guest_2,
                        appointmentID: snapshot.key,
                        timeOfAppointment: timeMiliTemp
                    });
                },1000);
            }
            if(guest_3 !== "undefined"){
                var guestPostRef3 = app.database().ref('/client_appointments/' + project_code + "/" + snapshot.key + "/users").push();

                guestPostRef3.set({
                    email: guest_3,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost3 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost3.set({
                        email:guest_3,
                        appointmentID: snapshot.key,
                        timeOfAppointment: timeMiliTemp
                    });
                },1000);
            }
            if(guest_4 !== "undefined"){
                console.log("send guest")
                var guestPostRef4 = app.database().ref('/client_appointments/' + project_code + "/" + snapshot.key + "/users").push();

                guestPostRef4.set({
                    email: guest_4,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost4 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost4.set({
                        email:guest_4,
                        appointmentID: snapshot.key,
                        timeOfAppointment: timeMiliTemp
                    });
                },1000);
            }

        }

        const AppointmentClick = () =>{
            window.location = finalLink;
        }


        const setNewAppointment = () =>{
            var appointmentPost = app.database().ref('/client_appointments/' + project_code).push();

            let appointmentTime = new Date(event_start_time_holder);
            var timeMili = appointmentTime.getTime();

            appointmentPost.set({
                appointmentID: appointmentPost.key,
                appointmentName: appointmentFullName,
                timeOfAppointment: timeMili,
                assignedTo: assigned_to,
                started: false
            });

            var userPostRef = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();
            //this generates push id then we push use set to push user


            userPostRef.set({
                email: invitee_email_holder,
                fullName: invitee_full_name_holder,
                phoneNumber: user_phone_number
            });

            //create link
            //pushID of the appointmengt + "_" + pushID
            var startRef = currentHref.split("/c");
            var urId = userPostRef.key;
            var newRef = startRef[0] + "?linkId=" +appointmentPost.key +"_split_" + urId;

            finalLink = newRef;
            //invitee_full_name_holder
            //invitee_email_holder
            //user_phone_number
            var setLink = document.getElementById("link")
            setLink.innerHTML = "Join Meeting";

            setLink.onclick = () => {AppointmentClick()};

            console.log("WE MADE AN APPOINTMENT");

            //set users email to the appointment list
            var emailPost = app.database().ref('/client_emails/' + project_code).push();

            emailPost.set({
                email:invitee_email_holder,
                appointmentID: appointmentPost.key,
                timeOfAppointment: timeMili
            });

            //do all things above for guests
            if(guest_1 !== "undefined"){
                var guestPostRef1 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();

                guestPostRef1.set({
                    email: guest_1,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });


                setTimeout(() => {
                    var emailGuestPost1 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost1.set({
                        email:guest_1,
                        appointmentID: appointmentPost.key,
                        timeOfAppointment: timeMili
                    });
                },1000);
            }
            if(guest_2 !== "undefined"){
                var guestPostRef2 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();
                
                guestPostRef2.set({
                    email: guest_2,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost2 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost2.set({
                        email:guest_2,
                        appointmentID: appointmentPost.key,
                        timeOfAppointment: timeMili
                    });
                },1000);
            }
            if(guest_3 !== "undefined"){
                var guestPostRef3 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();

                guestPostRef3.set({
                    email: guest_3,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost3 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost3.set({
                        email:guest_3,
                        appointmentID: appointmentPost.key,
                        timeOfAppointment: timeMili
                    });
                },1000);
            }
            if(guest_4 !== "undefined"){
                console.log("send guest")
                var guestPostRef4 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();

                guestPostRef4.set({
                    email: guest_4,
                    fullName: "undefined",
                    phoneNumber: "undefined"
                });

                setTimeout(() => {
                    var emailGuestPost4 = app.database().ref('/client_emails/' + project_code).push();

                    emailGuestPost4.set({
                        email:guest_4,
                        appointmentID: appointmentPost.key,
                        timeOfAppointment: timeMili
                    });
                },1000);
            }

        }

        findAppointment();
    }
    
    

    render(){
        return (
            <>
                <div>
                    <img className="BackBanner" src={backBanner} alt="Banner" />;
                    <img className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
                </div>
                <div className="BlackFrontOverlay">
                    <h2 className="blackBoxTitle">Appointment Confirmation</h2>
                    
                        <p className="GreenTitle">Title</p>
                        <p className="paragraphReg" id="title">Calendly Confirmation</p>
                        <p className="GreenTitle">Your Name</p>
                        <p className="paragraphReg" id="fullName">Full Name</p>
                        <p className="GreenTitle">Email</p>
                        <p className="paragraphReg" id="userEmail">User Email</p>
                        <p className="GreenTitle">Phone Number</p>
                        <p className="paragraphReg" id="userPhone">User Email</p>
                        <p className="GreenTitle">Appointment Date</p>
                        <p className="paragraphReg" id="startTime">Start Time</p>
                        <p className="GreenTitle">Guest invitees</p>
                        <p className="paragraphReg" id="guestList">No Guests</p>
                        <button className="joinMeetingButton" id="link">Link</button>
                    
                </div>
            </>
        );
    }
};


export default Confirmation;
